<div class="mq text-center" behavior="alternate">
    <!-- <Marquee behavior="alternate" 
  direction="left" 
  scrollamount="5"
  style="color: yellow;
         font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 
                      'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
         width: 100%;
         font-size: 18px;">University will remain closed from <strong>17th July to 23rd July </strong>on account of KANWAR YATRA.</Marquee> -->
    <h5 class="note m text-white">
        <b>Notice:</b> July 2025 Examination Date Sheet.
        <a
            (click)="goToRefresh('/examination-schedule')"
            routerLink="/examination-schedule"
            class="blink"
            style="font-size: large"
            >Check Here</a
        >
    </h5>
</div>
